import SidebarItem from '../../components/layout/sidebar/SidebarItem';
import Sidebar from '../../components/layout/sidebar/Sidebar';
import 'boxicons';

const HomepageSidebar = ({defaultActiveKey}) => {


    return (
        <Sidebar defaultActiveKey={defaultActiveKey}>
            <SidebarItem eventKey={"home"} to={'/home'}>
                <box-icon name='home' type='solid' color='white' ></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Home</span>
            </SidebarItem>
            <SidebarItem eventKey={"artworks"} to={'/artworks'}>
                <box-icon color='white' type='solid' name='palette'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Artworks</span>
            </SidebarItem>
            <SidebarItem eventKey={"collections"} to={'/collections'}>
                <box-icon color='white' type='solid' name='photo-album'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Collections</span>
            </SidebarItem>
            <SidebarItem eventKey={"certificates"} to={'/certificates'}>
                <box-icon color='white' type='solid' name='file'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Certificates</span>
            </SidebarItem>
            <SidebarItem eventKey={"nfts"} to={'/nfts'}>
                <box-icon color='white' type='solid' name='certification'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">NFTs</span>
            </SidebarItem>
            <SidebarItem eventKey={"explore"} to={'/explore'}>
                <box-icon name='world' color='white' ></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Explore</span>
            </SidebarItem>
        </Sidebar>
    );
}

export default HomepageSidebar;